import logoCompass from '@/assets/logo-compass.png';

export function LoadingSpinner({ className = 'h-10 w-10' }: { className?: string }) {
  return (
    <div className="flex justify-center py-12">
      <img src={logoCompass} alt="Content loading" className={`${className} animate-spin`} style={{ animationDuration: '3s' }} />
    </div>
  );
}
